<detail-summary-items>

    <style>
        .contents_table th{
            font-size:0.8rem;
        }
        .contents_table td{
            font-size:1.2rem;
        }
        .project_title{
            width:30%;
        }
        .contents_table.pay-detail_table tr td.project_title_val{
            font-size:1rem;
            padding-right: 2rem;
        }
        .contents_table td.amount{
            font-weight: bold;
            font-size: 1.35rem;
        }
        .tax_withholding{
            color:red
        }
    </style>


    <div class="container_heading">
        <h2 class="heading-02" style="padding-left: 0">
            受注プロジェクト一覧
        </h2>
    </div>
    <table class="contents_table pay-detail_table margin-spacing-3_top">
        <tbody>
            <tr>
                <th>プロジェクトID</th>
                <th class="project_title">プロジェクトタイトル</th>
                <th>受注確定年月日</th>
                <th>受注金額<br>（税抜）</th>
                <th>消費税額</th>
                <th>源泉額</th>
                <th style="font-weight: bold">受取額（税込）</th>
                <th>募集件数</th>
                <th>納品数<br>（うち報酬未払<br>のもの）</th>

                <th>未納品数</th>
                <th>受取済<br>報酬総額</th>
                <th>CROCO預り中の<br>報酬残額</th>
            </tr>


            <tr each={item in props.items}>
                <td>{item.project_id}</td>
                <td class="project_title_val">{item.project_title}</td>
                <td>{date_format(item.paid_at_project)}</td>
                <td><number-format number={item.sub_amount}></number-format>円</td>
                <td><number-format number={item.tax}></number-format>円</td>
                <td>

                    <span if={props.company_type==1}>
                        ---
                    </span>
                    <span if={props.company_type==2} class="tax_withholding">
                        <number-format number={item.tax_withholding}></number-format>円
                    </span>
                </td>
                <td class="amount"><number-format number={item.amount}></number-format>円</td>
                <td><number-format number={item.max_volume}></number-format>件</td>
                <td>
                    <number-format number={item.delivery_count}></number-format>
                    (<number-format number={item.delivery_count - item.paid_delivery_count}></number-format>)
                </td>

                <td><number-format number={item.max_volume - item.delivery_count}></number-format></td>
                <td><number-format number={item.paid_reward_price}></number-format>円</td>
                <td><number-format number={item.not_paid_reward_price}></number-format>円</td>
            </tr>
        </tbody>
    </table>

    <script>
        import dayjs     from "dayjs";

        export default {
            components: {
            },
            state:{

            },
            date_format(datetime){
                return dayjs(datetime).format("YYYY年MM月DD日");
            },
        }
    </script>
</detail-summary-items>